export enum Tardiness{
	OnTime = "on-time",
	Late = "late",
	Absent = "absent",
}